import { DATE_COLUMN_TYPES, NUMBER_COLUMN_TYPES } from 'components/spreadsheet/constants/const'
import { ITableViewColumn } from 'types'

/**
 * Things a table owner could ask MortaAI to build, made from the table's own columns so the new Custom
 * View's prompt shows what's possible with this data. Each finishes "Ask MortaAI to build …".
 */
export const FALLBACK_IDEAS = [
  "a dashboard of this table's key numbers",
  'a report I can share with my team',
  'a page that answers the questions people ask about this data'
]

const MAX_IDEAS = 5

export function viewIdeas(columns: ITableViewColumn[], tableName: string): string[] {
  const named = columns.filter((column) => column.name.trim())
  const first = (test: (column: ITableViewColumn) => boolean) => named.find(test)?.name.trim()
  const table = tableName.trim()

  const select = first((column) => column.kind === 'select')
  const number = first((column) => NUMBER_COLUMN_TYPES.includes(column.kind))
  const date = first((column) => DATE_COLUMN_TYPES.includes(column.kind))
  const checkbox = first((column) => column.kind === 'checkbox')

  // Most visual first: the first idea is the one people see typed out.
  const ideas = [
    select && table && `a board of ${table} by ${select}`,
    number && select && `a chart of ${number} by ${select}`,
    number && !select && `a summary of the total ${number}`,
    date && `a list of what's due this week by ${date}`,
    checkbox && `a progress tracker for ${checkbox}`,
    table && `a form for adding new ${table}`
  ].filter((idea): idea is string => Boolean(idea))

  if (ideas.length === 0) return FALLBACK_IDEAS
  return [...ideas, ...FALLBACK_IDEAS].slice(0, MAX_IDEAS)
}
